import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  primaryText: {
    color: theme.palette.primary.main
  },

  secondaryText: {
    fontSize: '18px',
    color: theme.palette.neutral.main
  },

  uploaderIcon: {
    width:40,
    height:40,
    margin: theme.spacing(3)
  },

  rowUploader: {
    display:'flex',
    minHeight: 75
  },

  errorMessage: {
    width: '-webkit-fill-available',
    marginTop: theme.spacing(2),
    maxWidth: 'none',
  },

  errorIcon: {
    flex:1,
    fill: theme.palette.error.main,
    marginInlineEnd: theme.spacing(1)
  },

  successIcon: {
    flex:1,
    marginInlineEnd: theme.spacing(1)
  },

  closeIcon: {
    flex:1,
    marginLeft:'auto',
    cursor: 'pointer'
  },

  textFile: {
    flex:5,
  },

  uploadButton: {
    border: `1px solid ${theme.palette.neutral.light}`,
    borderRadius: 1000,

    transition: 'border 0.3s',

    '&:hover': {
      border: `1px solid ${theme.palette.primary.light}`,
    },
    padding:theme.spacing(2),
    minHeight: theme.spacing(4),
    minWidth: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(1)
  },

  fileBox: {
    wordBreak:'break-all',
    margin: theme.spacing(1),
    padding: theme.spacing(3),
    borderRadius: '15px',
    display:'flex',
    flex:7,
    alignItems: "center",
    justifyContent: 'center',
    backgroundColor: theme.palette.neutral.white,
  },

  selectTypeFile: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
    borderRadius: '15px',
    display:'flex',
    alignItems: "center",
    flex:3,
    justifyContent: 'center',
    backgroundColor: theme.palette.neutral.white,
  },

  selectDisabled: {
    width:200,
    '& .css-1laowgc-MuiSelect-select-MuiInputBase-input-MuiInput-input.MuiSelect-select.MuiSelect-select': {
      color: theme.palette.neutral.lighter,
    }
  },

  select: {
    width:200,
  },

  rowFile: {
    display:'flex',
    flex:10,
    maxHeight: 75
  },

  uploaderBox: {
    width:'auto',
    flexDirection: 'column',
    cursor:'pointer',
    display:'flex',
    alignItems: "center",
    justifyContent: 'center'
  },

  loaderIcon: {
    padding: theme.spacing(2)
  },

  cancelText: {
    color: theme.palette.primary.main,
    padding: theme.spacing(5),
    cursor: 'pointer'
  },

  dropzone : {
    display: "flex",
    flexDirection: "column",
    border: `5px dashed ${theme.palette.neutral.lighter}`,
    backgroundColor: theme.palette.neutral.lightest,
    borderRadius:'5px',
    padding: theme.spacing(2),
    overflowY: 'auto',
    overflowX: 'hidden'
  },
}))

export default useStyles
